import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkUnitGridData = {
  name?: string;
  order?: {
    customer?: {
      name?: string;
    };
  };
};

export const CustomerCell = React.memo(({ order, name }: KpiWorkUnitGridData) => {
  const customerName = order?.customer?.name;

  if (customerName) {
    return (
      <Tooltip title={customerName}>
        <Typography variant="body2" noWrap>
          {customerName}
        </Typography>
      </Tooltip>
    );
  }

  return (
    <Typography variant="body2" noWrap>
      {name ?? ''}
    </Typography>
  );
});

export default CustomerCell;
